import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Manufacturer, ManufacturerStatus } from './manufacturer-models';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Observable, BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerService {

  manufacturers = new BehaviorSubject<Manufacturer[]>([]);

  private _baseURL: string;

  private _applyURL: string;

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/manufacturer`;
    this._applyURL = `${this.coreConfig.endpoint}api/v1/applymanufacturer`;
    this._getManufacturerList();
  }

  getManufacturerList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Manufacturer>> {
    return this.httpClient.get<AutoTablePageableResponse<Manufacturer>>(`${this._baseURL}s`, { params })
      .pipe(tap(rs => this._getManufacturerList()));
  }

  getManufacturer(manufacturerName: string): Observable<Manufacturer> {
    return this.httpClient.get<Manufacturer>(`${this._baseURL}/${manufacturerName}`);
  }

  applyManufacturer(manufacturer: Manufacturer): Observable<Manufacturer> {
    return this.httpClient.post<Manufacturer>(`${this._applyURL}`, manufacturer);
  }

  newManufacturer(manufacturer: Manufacturer): Observable<Manufacturer> {
    return this.httpClient.post<Manufacturer>(`${this._baseURL}`, manufacturer);
  }

  updateManufacturer(manufacturer: Manufacturer): Observable<Manufacturer> {
    return this.httpClient.put<Manufacturer>(`${this._baseURL}/${manufacturer.manufacturername}`, manufacturer);
  }

  removeManufacturers(manufacturerName: string | string[]): Observable<any> {
    if (_.isArray(manufacturerName)) {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          id: manufacturerName
        },
      });
    } else {
      return this.httpClient.delete(`${this._baseURL}/${manufacturerName}`);
    }
  }

  updateManufacturerStatus(manufacturerName: string | string[], status: string): Observable<any> {
    if (_.isArray(manufacturerName)) {
      return this.httpClient.patch(`${this._baseURL}`, {}, {
        params: {
          id: manufacturerName,
          status
        },
      });
    } else {
      return this.httpClient.patch(`${this._baseURL}/${manufacturerName}`, {}, {
        params: {
          status
        }
      });
    }
  }

  private _getManufacturerList() {
    return this.httpClient.get<AutoTablePageableResponse<Manufacturer>>(`${this._baseURL}s`, {
      params: { pageSize: '9999', status: ManufacturerStatus.Normal }
    }).subscribe(result => this.manufacturers.next(result.pageItems));
  }
}
